import * as React from 'react'
import { Card, CardContent, CardHeader, Box } from '@mui/material'
import { StandardStateSelect } from './StandardStateSelect'
import { StandardSubjectSelect } from './StandardSubjectSelect'
import { KiddomStandards } from './KiddomStandards'

export const SearchKiddomStandards: React.FC = () => {
  const [selectedState, setSelectedState] = React.useState('')
  const [selectedSubject, setSelectedSubject] = React.useState('')

  // Invalidate subject when state changes
  React.useEffect(() => {
    setSelectedSubject('')
  }, [selectedState])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Card>
        <CardHeader
          title="Search Kiddom Standards"
          slotProps={{ title: { variant: 'h6' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', py: 0 }}>
            <StandardStateSelect
              value={selectedState}
              onChange={setSelectedState}
            />
            <StandardSubjectSelect
              value={selectedSubject}
              onChange={setSelectedSubject}
            />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardHeader
          title="Kiddom Standards"
          slotProps={{ title: { variant: 'subtitle1' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <KiddomStandards state={selectedState} subject={selectedSubject} />
        </CardContent>
      </Card>
    </Box>
  )
}
